export const ROLES = ['user', 'moderator', 'admin', 'superadmin'] as const;
export type Role = (typeof ROLES)[number];

export type Permission =
  | 'admin.access'
  | 'reports.view'
  | 'reports.resolve'
  | 'content.remove'
  | 'comments.remove'
  | 'users.view'
  | 'users.suspend'
  | 'users.setRole'
  | 'music.manage'
  | 'stats.view'
  | 'audit.view';

const MODERATOR: Permission[] = [
  'admin.access',
  'reports.view',
  'reports.resolve',
  'content.remove',
  'comments.remove',
  'users.view',
];
const ADMIN: Permission[] = [...MODERATOR, 'users.suspend', 'music.manage', 'stats.view', 'audit.view'];
const SUPERADMIN: Permission[] = [...ADMIN, 'users.setRole'];

export const ROLE_PERMISSIONS: Record<Role, ReadonlySet<Permission>> = {
  user: new Set(),
  moderator: new Set(MODERATOR),
  admin: new Set(ADMIN),
  superadmin: new Set(SUPERADMIN),
};

export function can(role: Role, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].has(permission);
}
